module.exports = __webpack_public_path__ + "img/Header-title-2-SVG.7dc6c015.svg";